<div class="circle tw:bg-cyan"></div>
<div class="circle tw:bg-red"></div>
<div class="circle tw:bg-primary"></div>